webpackJsonp([162898551421021],{

/***/ 333:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  margin: 0 auto;\n  padding: 3em 1.5em 2em;\n  text-align: center;\n'], ['\n  margin: 0 auto;\n  padding: 3em 1.5em 2em;\n  text-align: center;\n']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\n  text-align: center;\n  line-height: 1.6;\n  margin: 0 0 1em 0;\n'], ['\n  text-align: center;\n  line-height: 1.6;\n  margin: 0 0 1em 0;\n']),
	    _templateObject3 = _taggedTemplateLiteralLoose(['\n  font-size: 3em;\n  text-transform: capitalize;\n  font-weight: 600;\n  margin: 0 0 3rem 0;\n  line-height: 1.2;\n'], ['\n  font-size: 3em;\n  text-transform: capitalize;\n  font-weight: 600;\n  margin: 0 0 3rem 0;\n  line-height: 1.2;\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(58);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _styledComponents = __webpack_require__(7);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _reactHelmet = __webpack_require__(45);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var Box = _styledComponents2.default.div(_templateObject);
	
	var Text = _styledComponents2.default.p(_templateObject2);
	
	var Title = _styledComponents2.default.h1(_templateObject3);
	
	var NotFoundPage = function NotFoundPage() {
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      _reactHelmet2.default,
	      null,
	      _react2.default.createElement(
	        'title',
	        null,
	        '404 - Page Not Found'
	      )
	    ),
	    _react2.default.createElement(
	      Box,
	      null,
	      _react2.default.createElement(
	        Title,
	        null,
	        'Error 404'
	      ),
	      _react2.default.createElement(
	        Text,
	        null,
	        'Sorry, that page can\'t be found'
	      )
	    )
	  );
	};
	
	exports.default = NotFoundPage;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-404-js-5c71200f81eedd8decca.js